import {ON24, CctTodoView} from 'growth-todolist';
import {GROWTH_URL, ON24_URL_KEYWORD, CCT_TODOLIST} from '../growthConstants';
import {ErrorRoutes} from '../../../Routes/ErrorRoutes';
import {injectIntl} from 'react-intl';
import GrowthUtil from '../growthUtil';

type RoutesType = {
	path: string;
	component: any;
	titleId: string;
	exact?: boolean;
	pathRegex?: string;
};

const ON24Route: RoutesType = {
	component: injectIntl(ON24),
	path: `${GROWTH_URL}/${ON24_URL_KEYWORD}`,
	pathRegex: `${GROWTH_URL}/${ON24_URL_KEYWORD}/:product?/:page?`,
	titleId: 'app.document.title.apps',
};

const CctTodoListRoute: RoutesType = {
	component: injectIntl(CctTodoView),
	path: `${GROWTH_URL}/${CCT_TODOLIST}`,
	pathRegex: `${GROWTH_URL}/${CCT_TODOLIST}/:task/:subtask?`,
	titleId: 'app.document.title.apps',
};

// pushing routes behind the flag
export function projectRoutes() {
	const routes: RoutesType[] = [];
	if (GrowthUtil.hasFeature('temp_enable_webcast_workflow')) {
		routes.push(ON24Route);
	}
	if (GrowthUtil.hasFeature('temp_enable_cct_todo_workflow')) {
		routes.push(CctTodoListRoute);
	}

	// pushing error routes for invalid path
	routes.push(ErrorRoutes as any);

	return routes;
}
